const removeClass = (ele, ...classes) => ele.classList.remove(...classes);

export default removeClass;
